(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-sector', {
            parent: 'entity',
            url: '/customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sector/customer-sectors.html',
                    controller: 'CustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-sector-detail', {
            parent: 'customer-sector',
            url: '/customer-sector/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.customerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sector/customer-sector-detail.html',
                    controller: 'CustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerSector', function($stateParams, CustomerSector) {
                    return CustomerSector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer-sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-sector-detail.edit', {
            parent: 'customer-sector-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sector.new', {
            parent: 'customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                endedAt: null,
                                phone: null,
                                main: null,
                                monday: null,
                                tuesday: null,
                                wednesday: null,
                                thursday: null,
                                friday: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('customer-sector');
                });
            }]
        })
        .state('customer-sector.edit', {
            parent: 'customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sector.delete', {
            parent: 'customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-delete-dialog.html',
                    controller: 'CustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
